// extracted by mini-css-extract-plugin
export default {"column":"styles__column___qIasD","row":"styles__row___0L6-W"};